// extracted by mini-css-extract-plugin
module.exports = {"vWhite":"#fff","vUiHueLight":"#eee","vUiHue":"#ddd","wrapper":"HelpLink__wrapper___9AzgA","label":"HelpLink__label___Pm3hE"};